import {
  createFrontendModule,
  storageApiRef,
} from '@backstage/frontend-plugin-api';
import {
  AnalyticsImplementationBlueprint,
  AppRootWrapperBlueprint,
} from '@backstage/plugin-app-react';
import { Onboarding } from './Onboarding';
import { EVENT_ITEMS, markItemDone } from './progress';

/** Completes checklist items from the portal's analytics events (next to plugins/analytics). */
const onboardingAnalytics = AnalyticsImplementationBlueprint.make({
  name: 'onboarding',
  params: defineParams =>
    defineParams({
      deps: { storageApi: storageApiRef },
      factory: ({ storageApi }) => ({
        captureEvent: event => {
          const item = EVENT_ITEMS[event.action];
          if (item) markItemDone(storageApi, item).catch(() => {});
        },
      }),
    }),
});

/**
 * Welcome tour and « Premiers pas » checklist (docs/onboarding.md). The root wrapper renders
 * only once signed in, around the whole app.
 */
export const onboardingModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootWrapperBlueprint.make({
      name: 'onboarding',
      params: {
        component: ({ children }) => (
          <>
            {children}
            <Onboarding />
          </>
        ),
      },
    }),
    onboardingAnalytics,
  ],
});
